import { Badge } from "@material-ui/core";
import { Search, ShoppingCartOutlined } from "@material-ui/icons";
import React from "react";
import styled from "styled-components";
import { mobile } from "../responsive";

import { Link } from "react-router-dom";


import { Button } from "@material-ui/core";

const OnLink =styled(Link)`
text-decoration: none;
color: black;
`;
const Container = styled.div`
  height: 80px;
  border-bottom: 1px solid lightgray;
  ${mobile({ height: "60px" })}
`;

const Wrapper = styled.div`
  padding: 18px 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  ${mobile({ padding: "10px 0px" })}
`;

const Left = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  ${mobile({ display: "none" })}
`;

const Language = styled.span`
  font-size: 14px;
  cursor: pointer;
  ${mobile({ display: "none" })}
`;

const SearchContainer = styled.div`
  border: 0.5px solid lightgray;
  display: flex;
  align-items: center;
  margin-left: 25px;
  padding: 5px;
`;

const Input = styled.input`
  border: none;
  ${mobile({ width: "50px" })}
`;

const Center = styled.div`
  flex: 1;
  text-align: center;
  ${mobile({ flex: 2, justifyContent: "center" ,marginLeft:'10px'})}
`;

const Logo = styled.h1`
  align-items: center;
  color: #414141;
  margin-bottom: 0;
  font-family: 'Noto Serif TC', serif;
  ${mobile({ fontSize: "20px" })}
`;
const Right = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  ${mobile({ flex: 2, justifyContent: "center" })}
`;

const MenuItem = styled.div`
  font-size: 14px;
  cursor: pointer;
  margin-left: 25px;
  ${mobile({ fontSize: "12px", marginLeft: "10px" })}
`;


const Navbar = () => {
  //const cart=useSelector(state=>state.cart)
  
  return (
    <Container>
      <Wrapper>
        <Left>
          <Language>EN</Language>
          <SearchContainer>
            <Input placeholder="Search" />
            <Search style={{ color: "gray", fontSize: 16 }} />
          </SearchContainer>
        </Left>
        <Center>
        <OnLink to = '/commerce'>
          <Logo>Shuper平台 </Logo>
        </OnLink>
        </Center>
        <Right>
        <OnLink to = '/commerce/register'>
          <MenuItem>註冊</MenuItem>
        </OnLink>
        <OnLink to = '/commerce/login'>
          <MenuItem><Button >登出</Button> </MenuItem>
        </OnLink>
          <OnLink to = '/commerce/cart'>
          <MenuItem>
            <Badge badgeContent='2' color="primary">
              <ShoppingCartOutlined></ShoppingCartOutlined>
            </Badge>
          </MenuItem>
          </OnLink>
        </Right>
      </Wrapper>
    </Container>
  );
};

export default Navbar;
